<script>
export default {
  name: 'BaseSelect',
  props: {
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:value'],
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
      },
    },
  },
}
</script>

<template>
  <el-select
    v-model="internalValue"
    class="tamara-base-select"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:prefix>
      <slot name="prefix" />
    </template>
    <slot />
    <template v-slot:suffix>
      <slot name="suffix" />
    </template>
  </el-select>
</template>

<style lang="scss" scoped>
.tamara-base-select {
  $arrowIconColor: #999;

  ::v-deep {
    .el-input {
      .el-input__icon {
        &::before {
          color: $arrowIconColor;
        }
      }

      &.is-focus {
        .el-input__icon {
          &::before {
            color: $arrowIconColor;
          }
        }
      }
    }
  }
}
</style>
